import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import axios from '../axios';
import * as actions from '../store/actions/index';
import Config from '../components/configs';
import Success from '../components/UI/Success'
import Aux from '../hoc/auxi'
import {library} from '@fortawesome/fontawesome-svg-core'
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons'

import ModalConfig from '../components/UI/ModalConfig';
import ModalConfigDelete from '../components/UI/ModalConfigDelete';
import {FormattedMessage} from 'react-intl';


library.add(faTrashAlt)


class Configs extends Component {
    state = {
        redirect: false,
        message: null,
        newChronic: '',
        newMed: '',
        newPhysical: '',
        newSpiro: '',
        newVisual: '',
        newAuditory: '',
        newEcg: '',
        newEritrogram: '',
        newLeukogram: '',
        counter: 0,
        codeAttempts: '',
        loginAttempts: '',
        chronic: null,
        med: null,
        physical: null,
        spiro: null,
        visual: null,
        auditory: null,
        ecg: null,
        eritrogram: null,
        leukogram: null
    };

    fetchData() {
        this.props.onFetchChronicO();
        this.props.onFetchMeds();
        this.props.onFetchPhysicalV();
        this.props.onFetchSpiro();
        this.props.onFetchVisual();
        this.props.onFetchAuditory();
        this.props.onFetchEcg();
        this.props.onFetchEritrogram();
        this.props.onFetchLeukogram();
    }

    componentDidMount() {
        const token = 'Bearer ' + localStorage.getItem('token');
        axios.get(`http://localhost:7000/admin/checkadmin`, {headers: {"Authorization": token}})
            .then(({data}) => {
                if (data.status === 1) {
                    this.setState({
                        redirect: false
                    })
                } else {
                    this.setState({
                        redirect: true
                    })
                }
            })
            .catch(err => {
                console.log(err)
            });

        axios.get(`http://localhost:7000/admin/fetchattempts`)
            .then(({data}) => {
                if (data.status === 1) {
                    this.setState({
                        loginAttempts: data.results[0].global_login_attempts,
                        codeAttempts: data.results[0].global_code_attempts
                    })
                }
            })
            .catch(err => {
                console.log(err)
            });
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.counter !== this.state.counter) {
            this.fetchData();
        }
    }


    onLoginAttemptsChangeHandler = (event) => {
        this.setState({loginAttempts: event.target.value});
    };

    onCodeAttemptsChangeHandler = (event) => {
        this.setState({codeAttempts: event.target.value});
    };

    updateAttemptsSubmitHandler = (event) => {
        event.preventDefault();

        const data = {loginAttempts: this.state.loginAttempts, codeAttempts: this.state.codeAttempts}
        axios.post('admin/editattempts/', data)
            .then(response => {
                console.log(response);
                this.setState({message: response.data.message})

            })
            .catch(err => {
                console.log(err);
            })
    };

    newChronicChangeHandler = (event) => {
        this.setState({newChronic: event.target.value})
    };

    chronicSubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newChronic: this.state.newChronic}
        axios.post('admin/newchronic/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newChronic: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deleteChronic = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deletechronic/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    newMedChangeHandler = (event) => {
        this.setState({newMed: event.target.value})
    };

    medSubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newMed: this.state.newMed}
        axios.post('admin/newmed/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newMed: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deleteMed = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deletemed/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    newPhysicalVChangeHandler = (event) => {
        this.setState({newPhysical: event.target.value})
    };

    physicalVSubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newPhysical: this.state.newPhysical}
        axios.post('admin/newphysical/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newPhysical: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deletePhysical = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deletephysical/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    newSpiroChangeHandler = (event) => {
        this.setState({newSpiro: event.target.value})
    };

    spiroSubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newSpiro: this.state.newSpiro}
        axios.post('admin/newspiro/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newSpiro: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deleteSpiro = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deletespiro/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    newVisualChangeHandler = (event) => {
        this.setState({newVisual: event.target.value})
    };

    visualSubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newVisual: this.state.newVisual}
        axios.post('admin/newvisual/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newVisual: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deleteVisual = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deletevisual/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    newAuditoryChangeHandler = (event) => {
        this.setState({newAuditory: event.target.value})
    };

    auditorySubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newAuditory: this.state.newAuditory}
        axios.post('admin/newauditory/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newAuditory: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deleteAuditory = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deleteauditory/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    newEcgChangeHandler = (event) => {
        this.setState({newEcg: event.target.value})
    };

    ecgSubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newEcg: this.state.newEcg}
        axios.post('admin/newecg/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newEcg: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deleteEcg = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deleteecg/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    newEritrogramChangeHandler = (event) => {
        this.setState({newEritrogram: event.target.value})
    };

    eritrogramSubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newEritrogram: this.state.newEritrogram}
        axios.post('admin/neweritrogram/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newEritrogram: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deleteEritrogram = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deleteeritrogram/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    newLeukogramChangeHandler = (event) => {
        this.setState({newLeukogram: event.target.value})
    };

    leukogramSubmitHandler = (event) => {
        window.scrollTo(0, 0);
        event.preventDefault();
        const data = {newLeukogram: this.state.newLeukogram}
        axios.post('admin/newLeukogram/', data)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1,
                    newLeukogram: ''
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };

    deleteLeukogram = (event) => {
        window.scrollTo(0, 0);
        axios.post('admin/deleteleukogram/' + event.target.id)
            .then(response => {
                this.setState((prevState) => ({
                    message: response.data.message,
                    counter: prevState.counter + 1
                }))
            })
            .catch(err => {
                console.log(err);
            })
    };


    render() {
        let chronicOSelect = this.props.chronicO.map(chronicO => {
            this.chronicChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({chronic: null});
                } else {
                    this.setState({chronic: event.target.value});
                }
            };

            this.onEditChronicHandler = (event) => {
                let id = null;
                const data = {
                    chronic: this.state.chronic,
                    id: chronicO.id_chronic_diseases_value
                }
                axios.post('admin/editchronic/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={chronicO.id_chronic_diseases_value}>
                {chronicO.value}
                <span className="row">
                <ModalConfig modalId={"modalchronic" + chronicO.id_chronic_diseases_value}
                             class="btn btn-secondary mr-2"
                             btnText={<FormattedMessage id="edit-button"/>}
                             modalText={chronicO.value}
                             action={<FormattedMessage id="edit-button"/>}
                             onChange={this.chronicChangeHandler}
                             confirm={this.onEditChronicHandler}
                />
                    <ModalConfigDelete modalId={"deletechronic" + chronicO.id_chronic_diseases_value}
                                       class="btn btn-danger mr-2"
                                       btnText={<FormattedMessage id="edit-button"/>}
                                       modalText={chronicO.value}
                                       action="Eliminar"
                                       confirm={this.deleteChronic}
                                       deleteId={chronicO.id_chronic_diseases_value}
                    />
                </span>
            </li>)
        });
        let medsSelect = this.props.meds.map(meds => {
            this.medChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({med: null});
                } else {
                    this.setState({med: event.target.value});
                }
            };

            this.onEditMedHandler = (event) => {
                let id = null;
                const data = {
                    med: this.state.med,
                    id: meds.id_takes_meds_value
                }
                axios.post('admin/editmed/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={meds.id_takes_meds_value}>
                {meds.value}
                <span className="row">
                     <ModalConfig modalId={"modalmeds" + meds.id_takes_meds_value}
                                  class="btn btn-secondary mr-2"
                                  btnText={<FormattedMessage id="edit-button"/>}
                                  modalText={meds.value}
                                  onChange={this.medChangeHandler}
                                  action={<FormattedMessage id="edit-button"/>}
                                  confirm={this.onEditMedHandler}
                     />
                        <ModalConfigDelete modalId={"deletemed" + meds.id_takes_meds_value}
                                           class="btn btn-danger mr-2"
                                           btnText={<FormattedMessage id="edit-button"/>}
                                           modalText={meds.value}
                                           action="Eliminar"
                                           confirm={this.deleteMed}
                                           deleteId={meds.id_takes_meds_value}
                        />
                </span>
            </li>)
        });
        let physicalVSelect = this.props.physicalV.map(physicalV => {
            this.physicalChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({physical: null});
                } else {
                    this.setState({physical: event.target.value});
                }
            };

            this.onEditPhysicalHandler = (event) => {
                let id = null;
                const data = {
                    physical: this.state.physical,
                    id: physicalV.id_physical_activity_value
                }
                axios.post('admin/editphysical/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={physicalV.id_physical_activity_value}>
                {physicalV.value}
                <span className="row">
                     <ModalConfig modalId={"modalphysical" + physicalV.id_physical_activity_value}
                                  class="btn btn-secondary mr-2"
                                  btnText={<FormattedMessage id="edit-button"/>}
                                  modalText={physicalV.value}
                                  onChange={this.physicalChangeHandler}
                                  action={<FormattedMessage id="edit-button"/>}
                                  confirm={this.onEditPhysicalHandler}
                     />
                    <ModalConfigDelete modalId={"deletephysical" + physicalV.id_physical_activity_value}
                                       class="btn btn-danger mr-2"
                                       btnText={<FormattedMessage id="edit-button"/>}
                                       modalText={physicalV.value}
                                       action="Eliminar"
                                       confirm={this.deletePhysical}
                                       deleteId={physicalV.id_physical_activity_value}
                    />
                    </span>
            </li>)
        });

        let spiroSelect = this.props.spiro.map(spiro => {
            this.spiroChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({spiro: null});
                } else {
                    this.setState({spiro: event.target.value});
                }
            };

            this.onEditSpiroHandler = (event) => {
                let id = null;
                const data = {
                    spiro: this.state.spiro,
                    id: spiro.id_spirometry_change
                }
                axios.post('admin/editspiro/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={spiro.id_spirometry_change}>
                {spiro.value}
                <span className="row">
                     <ModalConfig modalId={"modalspiro" + spiro.id_spirometry_change}
                                  class="btn btn-secondary mr-2"
                                  btnText={<FormattedMessage id="edit-button"/>}
                                  modalText={spiro.value}
                                  onChange={this.spiroChangeHandler}
                                  action={<FormattedMessage id="edit-button"/>}
                                  confirm={this.onEditSpiroHandler}
                     />

                     <ModalConfigDelete modalId={"deletespiro" + spiro.id_spirometry_change}
                                        class="btn btn-danger mr-2"
                                        btnText={<FormattedMessage id="edit-button"/>}
                                        modalText={spiro.value}
                                        action="Eliminar"
                                        confirm={this.deleteSpiro}
                                        deleteId={spiro.id_spirometry_change}
                     />
                </span>
            </li>)
        });

        let visualSelect = this.props.visual.map(visual => {
            this.visualChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({visual: null});
                } else {
                    this.setState({visual: event.target.value});
                }
            };

            this.onEditVisualHandler = (event) => {
                let id = null;
                const data = {
                    visual: this.state.visual,
                    id: visual.id_visual_screening_change
                }
                axios.post('admin/editvisual/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={visual.id_visual_screening_change}>
                {visual.value}
                <span className="row">
                     <ModalConfig modalId={"modalvisual" + visual.id_visual_screening_change}
                                  class="btn btn-secondary mr-2"
                                  btnText={<FormattedMessage id="edit-button"/>}
                                  modalText={visual.value}
                                  onChange={this.visualChangeHandler}
                                  action={<FormattedMessage id="edit-button"/>}
                                  confirm={this.onEditVisualHandler}
                     />
                    <ModalConfigDelete modalId={"deletevisual" + visual.id_visual_screening_change}
                                       class="btn btn-danger mr-2"
                                       btnText={<FormattedMessage id="edit-button"/>}
                                       modalText={visual.value}
                                       action="Eliminar"
                                       confirm={this.deleteVisual}
                                       deleteId={visual.id_visual_screening_change}
                    />
                </span>
            </li>)
        });

        let auditorySelect = this.props.auditory.map(auditory => {
            this.auditoryChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({auditory: null});
                } else {
                    this.setState({auditory: event.target.value});
                }
            };

            this.onEditAuditoryHandler = (event) => {
                let id = null;
                const data = {
                    auditory: this.state.auditory,
                    id: auditory.id_auditory_screening_change
                }
                axios.post('admin/editauditory/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={auditory.id_auditory_screening_change}>
                {auditory.value}
                <span className="row">
                     <ModalConfig modalId={"modalauditory" + auditory.id_auditory_screening_change}
                                  class="btn btn-secondary mr-2"
                                  btnText={<FormattedMessage id="edit-button"/>}
                                  modalText={auditory.value}
                                  onChange={this.auditoryChangeHandler}
                                  action={<FormattedMessage id="edit-button"/>}
                                  confirm={this.onEditAuditoryHandler}
                     />
                <ModalConfigDelete modalId={"deleteauditory" + auditory.id_auditory_screening_change}
                                   class="btn btn-danger mr-2"
                                   btnText={<FormattedMessage id="edit-button"/>}
                                   modalText={auditory.value}
                                   action="Eliminar"
                                   confirm={this.deleteAuditory}
                                   deleteId={auditory.id_auditory_screening_change}
                />
                </span>
            </li>)
        });

        let ecgSelect = this.props.ecg.map(ecg => {
            this.ecgChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({ecg: null});
                } else {
                    this.setState({ecg: event.target.value});
                }
            };

            this.onEditEcgHandler = (event) => {
                let id = null;
                const data = {
                    ecg: this.state.ecg,
                    id: ecg.id_ecg_change
                }
                axios.post('admin/editecg/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={ecg.id_ecg_change}>
                {ecg.value}
                <span className="row">
                     <ModalConfig modalId={"modalecg" + ecg.id_ecg_change}
                                  class="btn btn-secondary mr-2"
                                  btnText={<FormattedMessage id="edit-button"/>}
                                  modalText={ecg.value}
                                  onChange={this.ecgChangeHandler}
                                  action={<FormattedMessage id="edit-button"/>}
                                  confirm={this.onEditEcgHandler}
                     />
                <ModalConfigDelete modalId={"deleteecg" + ecg.id_ecg_change}
                                   class="btn btn-danger mr-2"
                                   btnText={<FormattedMessage id="edit-button"/>}
                                   modalText={ecg.value}
                                   action="Eliminar"
                                   confirm={this.deleteEcg}
                                   deleteId={ecg.id_ecg_change}
                />
                </span>
            </li>)
        });

        let eritrogramSelect = this.props.eritrogram.map(eritrogram => {
            this.eritrogramChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({eritrogram: null});
                } else {
                    this.setState({eritrogram: event.target.value});
                }
            };

            this.onEditEritrogramHandler = (event) => {
                let id = null;
                const data = {
                    eritrogram: this.state.eritrogram,
                    id: eritrogram.id_eritrogram_change
                }
                axios.post('admin/editeritrogram/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={eritrogram.id_eritrogram_change}>
                {eritrogram.value}
                <span className="row">
                     <ModalConfig modalId={"modaleritrogram" + eritrogram.id_eritrogram_change}
                                  class="btn btn-secondary mr-2"
                                  btnText={<FormattedMessage id="edit-button"/>}
                                  modalText={eritrogram.value}
                                  onChange={this.eritrogramChangeHandler}
                                  action={<FormattedMessage id="edit-button"/>}
                                  confirm={this.onEditEritrogramHandler}
                     />
                <ModalConfigDelete modalId={"deleteeritrogram" + eritrogram.id_eritrogram_change}
                                   class="btn btn-danger mr-2"
                                   btnText={<FormattedMessage id="edit-button"/>}
                                   modalText={eritrogram.value}
                                   action="Eliminar"
                                   confirm={this.deleteEritrogram}
                                   deleteId={eritrogram.id_eritrogram_change}
                />
                </span>
            </li>)
        });

        let leukogramSelect = this.props.leukogram.map(leukogram => {
            this.leukogramChangeHandler = (event) => {
                if (event.target.value === "null") {
                    this.setState({leukogram: null});
                } else {
                    this.setState({leukogram: event.target.value});
                }
            };

            this.onEditLeukogramHandler = (event) => {
                let id = null;
                const data = {
                    leukogram: this.state.leukogram,
                    id: leukogram.id_leukogram_change
                }
                axios.post('admin/editleukogram/', data)
                    .then(response => {
                        console.log(id);
                        this.setState((prevState) => ({
                            message: response.data.message,
                            counter: prevState.counter + 1,
                        }))
                    })
                    .catch(err => {
                        console.log(err);
                    })
            };
            return (<li className="list-group-item d-flex justify-content-between align-items-center"
                        key={leukogram.id_leukogram_change}>
                {leukogram.value}
                <span className="row">
                     <ModalConfig modalId={"modalleukogram" + leukogram.id_leukogram_change}
                                  class="btn btn-secondary mr-2"
                                  btnText={<FormattedMessage id="edit-button"/>}
                                  modalText={leukogram.value}
                                  onChange={this.leukogramChangeHandler}
                                  action={<FormattedMessage id="edit-button"/>}
                                  confirm={this.onEditLeukogramHandler}
                     />
                <ModalConfigDelete modalId={"deleteleukogram" + leukogram.id_leukogram_change}
                                   class="btn btn-danger mr-2"
                                   btnText={<FormattedMessage id="edit-button"/>}
                                   modalText={leukogram.value}
                                   action="Eliminar"
                                   confirm={this.deleteLeukogram}
                                   deleteId={leukogram.id_leukogram_change}
                />
                </span>
            </li>)
        });

        if (this.state.redirect) {
            return <Redirect to="/"/>
        }

        let message = null;
        if (this.state.message) {
            message = <Success text={this.state.message}/>
        }

        return (
            <Aux>
                {message}
                <Config
                    codeAttempts={this.state.codeAttempts}
                    loginAttempts={this.state.loginAttempts}

                    configSubmit={this.updateAttemptsSubmitHandler}
                    loginAttemptsChange={this.onLoginAttemptsChangeHandler}
                    codeAttemptsChange={this.onCodeAttemptsChangeHandler}

                    med={medsSelect}
                    newMedChange={this.newMedChangeHandler}
                    medSubmit={this.medSubmitHandler}

                    chronicValue={this.state.newChronic}
                    chronic={chronicOSelect}
                    newChronicChange={this.newChronicChangeHandler}
                    chronicSubmit={this.chronicSubmitHandler}

                    physicalV={physicalVSelect}
                    newPhysicalVChange={this.newPhysicalVChangeHandler}
                    physicalVSubmit={this.physicalVSubmitHandler}

                    spiro={spiroSelect}
                    newSpiroChange={this.newSpiroChangeHandler}
                    spiroSubmit={this.spiroSubmitHandler}

                    visual={visualSelect}
                    newVisualChange={this.newVisualChangeHandler}
                    visualSubmit={this.visualSubmitHandler}

                    auditory={auditorySelect}
                    newAuditoryChange={this.newAuditoryChangeHandler}
                    auditorySubmit={this.auditorySubmitHandler}

                    ecg={ecgSelect}
                    newEcgChange={this.newEcgChangeHandler}
                    ecgSubmit={this.ecgSubmitHandler}

                    eritrogram={eritrogramSelect}
                    newEritrogramChange={this.newEritrogramChangeHandler}
                    eritrogramSubmit={this.eritrogramSubmitHandler}

                    leukogram={leukogramSelect}
                    newLeukogramChange={this.newLeukogramChangeHandler}
                    leukogramSubmit={this.leukogramSubmitHandler}
                />
            </Aux>
        )
    }
}

const mapStateToProps = state => {
    return {
        chronicO: state.fetchRefValues.chronicValues,
        meds: state.fetchRefValues.medsValues,
        physicalV: state.fetchRefValues.physicalActivityValues,
        spiro: state.fetchRefValues.spirometryChangeValues,
        visual: state.fetchRefValues.visualChangeValues,
        auditory: state.fetchRefValues.auditoryChangeValues,
        ecg: state.fetchRefValues.ecgChangeValues,
        eritrogram: state.fetchRefValues.eritrogramChangeValues,
        leukogram: state.fetchRefValues.leukogramChangeValues
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchChronicO: () => dispatch(actions.fetchChronicDiseasesValues()),
        onFetchMeds: () => dispatch(actions.fetchTakesMedsValues()),
        onFetchPhysicalV: () => dispatch(actions.fetchPhysicalValues()),
        onFetchSpiro: () => dispatch(actions.fetchSpirometryChangeValues()),
        onFetchVisual: () => dispatch(actions.fetchVisualChangeValues()),
        onFetchAuditory: () => dispatch(actions.fetchAuditoryChangeValues()),
        onFetchEcg: () => dispatch(actions.fetchEcgChangeValues()),
        onFetchEritrogram: () => dispatch(actions.fetchEritrogramChangeValues()),
        onFetchLeukogram: () => dispatch(actions.fetchLeukogramChangeValues()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Configs);



// WEBPACK FOOTER //
// ./src/containers/Configs.js